module.exports = __webpack_public_path__ + "static/img/41-北京第二实验小学(新文化街校区)1.49af5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/41-北京第二实验小学(新文化街校区)1.png
// module id = xKFP
// module chunks = 0